export default __webpack_public_path__ + "static/media/banner-1-item-1-mobile.50431f9e.png";